import qs from 'qs';
export const getQueryString = () => {
  const _queryString = window.location.href.split('?');
  return qs.parse(_queryString[1]) || null;
};
